// JsFromRoutes CacheKey 010874ba3460f267a8094d6eda45cbde
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/:org_nano_id/setup/posts'),
}
